{
  "hero": {
    "eyebrow": "Updates",
    "title": "Phase 1 build log",
    "lead": "Public milestones follow the project plan. Entries are planned unless later documentation confirms completion."
  },
  "list": { "title": "Milestones" },
  "detail": { "back": "Back to Updates", "related": "More updates" },
  "items": {
    "phase-one-kickoff": {
      "date": "Sep 2026",
      "tag": "Planned",
      "title": "Setup, familiarization, and component verification",
      "summary": "Finalize Phase 1 scope, architecture, safety procedures, procurement records, and basic component checks.",
      "body": [
        "September confirms requirements, CAD and electrical plans, sensor plan, software outline, and testing checklists.",
        "Teams onboard tools and verify parts before October integration so missing or unreliable components are caught early."
      ]
    },
    "integrated-prototype": {
      "date": "Oct 2026",
      "tag": "Planned",
      "title": "Parallel subsystem build",
      "summary": "Mechanical frame, electronics bench tests, and component-level software modules ready for integration.",
      "body": [
        "Mechanical fabricates the floating platform and mounts; Electrical bench-tests power, sensors, and communication; Software builds acquisition, control, and logging modules.",
        "An end-of-month readiness check confirms subsystems are prepared for November controlled-water integration."
      ]
    },
    "controlled-water-testing": {
      "date": "Nov 2026",
      "tag": "Planned",
      "title": "Integration and controlled-water validation",
      "summary": "Cross-team testing of buoyancy, waterproofing, propulsion, calibration, logging, and the first visualization pipeline.",
      "body": [
        "November shifts from component work to integrated system behaviour in controlled water.",
        "Failures, corrective actions, and residual risks are logged before December validation."
      ]
    },
    "approved-pond-window": {
      "date": "Dec 2026",
      "tag": "Conditional",
      "title": "Full-system validation and optional campus still-water demo",
      "summary": "Complete controlled-water test event; campus still-water testing only if permission, weather, and safety allow.",
      "body": [
        "Controlled-water validation is the required target. Approved campus water-body testing remains a stretch outcome.",
        "Outputs include usable CSV logs, route/trend visualizations, and at least one spatial visualization where data quality permits."
      ]
    },
    "ams-report-archive": {
      "date": "Jan 2027",
      "tag": "Planned",
      "title": "Final report and handoff archive",
      "summary": "Submit the final project report and organized archive by January 31, 2027.",
      "body": [
        "January focuses on reporting rather than new hardware development.",
        "The archive covers CAD, wiring, code, calibration, tests, safety, maintenance, and recommendations for future phases."
      ]
    }
  }
}
